import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/conenter/home.vue'
import enterprise from '../components/conenter/enterprise.vue'//企业设置首页
import company from '../components/conenter/company.vue'//企业列表
import addenterprise from '../components/conenter/addenterprise.vue'//添加公司
import details from '../components/conenter/details.vue'//企业详细
import invitation from '../components/conenter/invitation.vue'//邀请页面
import failure from '../components/conenter/failure.vue'//邀请链接失效
import tradecloud from '../components/tradecloud/tradecloud.vue'//贸易云页面
import makecloud from '../components/makecloud/makecloud.vue'//贸易云页面

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '*',
      redirect:'/home'
    },
    {
      path:'/invitation',
      name:'invitation',
      component:invitation
    },
    {
      path:'/failure',
      name:'failure',
      component:failure
    },
    {
      path: '/enterprise',
      name: 'enterprise',
      component: enterprise,
      children:[
        {
          path: '/',
          name: 'company',
          component: company,
        },
        {
          path: '/addenterprise',
          name: 'addenterprise',
          component: addenterprise,
        },
        {
          path: '/details',
          name: 'details',
          component: details,
        },
      ]
    },{
      path:'/tradecloud',
      name:'tradecloud',
      component:tradecloud
    },{
      path:'/makecloud',
      name:'makecloud',
      component:makecloud
    },
    {
      path: '/register',
      name: 'register',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js